export const isUUIDv4 = (value?: unknown): boolean => {
  if (!value) {
    return false
  }
  if (typeof value !== 'string') {
    return false
  }
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
    value,
  )
}
